import React from 'react';
import styles from './AdListLoader.scss';
import { Col, Row } from 'antd';

const AdsSectionLoader = (props) => {
    const {isMobile} = props;

    return (
        <Row className={`${isMobile ? styles.contentMobile : styles.content}`} type="flex">
            <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={6}>
                <div className={styles.adSingle}>
                    <div className={`${styles.adImage} ${styles.skeletonLoader}`}></div>

                    <div className={styles.adInfo}>
                        <div className={`${styles.date} ${styles.skeletonLoader}`}></div>
                        <span className={`${styles.title} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.attributes} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.priceEur} ${styles.skeletonLoader}`}></span>
                    </div>
                </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={6}>
                <div className={styles.adSingle}>
                    <div className={`${styles.adImage} ${styles.skeletonLoader}`}></div>

                    <div className={styles.adInfo}>
                        <div className={`${styles.date} ${styles.skeletonLoader}`}></div>
                        <span className={`${styles.title} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.attributes} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.priceEur} ${styles.skeletonLoader}`}></span>
                    </div>
                </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={6}>
                <div className={styles.adSingle}>
                    <div className={`${styles.adImage} ${styles.skeletonLoader}`}></div>

                    <div className={styles.adInfo}>
                        <div className={`${styles.date} ${styles.skeletonLoader}`}></div>
                        <span className={`${styles.title} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.attributes} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.priceEur} ${styles.skeletonLoader}`}></span>
                    </div>
                </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={6}>
                <div className={styles.adSingle}>
                    <div className={`${styles.adImage} ${styles.skeletonLoader}`}></div>

                    <div className={styles.adInfo}>
                        <div className={`${styles.date} ${styles.skeletonLoader}`}></div>
                        <span className={`${styles.title} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.attributes} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.priceEur} ${styles.skeletonLoader}`}></span>
                    </div>
                </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={6}>
                <div className={styles.adSingle}>
                    <div className={`${styles.adImage} ${styles.skeletonLoader}`}></div>

                    <div className={styles.adInfo}>
                        <div className={`${styles.date} ${styles.skeletonLoader}`}></div>
                        <span className={`${styles.title} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.attributes} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.priceEur} ${styles.skeletonLoader}`}></span>
                    </div>
                </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={6}>
                <div className={styles.adSingle}>
                    <div className={`${styles.adImage} ${styles.skeletonLoader}`}></div>

                    <div className={styles.adInfo}>
                        <div className={`${styles.date} ${styles.skeletonLoader}`}></div>
                        <span className={`${styles.title} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.attributes} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.priceEur} ${styles.skeletonLoader}`}></span>
                    </div>
                </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={6}>
                <div className={styles.adSingle}>
                    <div className={`${styles.adImage} ${styles.skeletonLoader}`}></div>

                    <div className={styles.adInfo}>
                        <div className={`${styles.date} ${styles.skeletonLoader}`}></div>
                        <span className={`${styles.title} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.attributes} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.priceEur} ${styles.skeletonLoader}`}></span>
                    </div>
                </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={6}>
                <div className={styles.adSingle}>
                    <div className={`${styles.adImage} ${styles.skeletonLoader}`}></div>

                    <div className={styles.adInfo}>
                        <div className={`${styles.date} ${styles.skeletonLoader}`}></div>
                        <span className={`${styles.title} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.attributes} ${styles.skeletonLoader}`}></span>
                        <span className={`${styles.priceEur} ${styles.skeletonLoader}`}></span>
                    </div>
                </div>
            </Col>
        </Row>

    )
}


export default AdsSectionLoader;



// WEBPACK FOOTER //
// ./src/components/AdListLoader/index.tsx